import { useState, useEffect } from 'react';

export const useRoturaImages = () => {
  const [images, setImages] = useState({
    gloveHandDerecha: '/img/rotura/manoizquierda.png',
    gloveHandIzquierda: '/img/rotura/manoderecha.png',
    gloveFoot: '/img/rotura/pieizquierdorotura.png',
    gloveFootLeft: '/img/rotura/piederechorotura.png',
    playerHead: '/img/rotura/cabezarotura.png',
    playerBody: '/img/rotura/traje.png',
    loading: true
  });

  useEffect(() => {
    const fetchGender = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setImages(prev => ({ ...prev, loading: false }));
          return;
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/profile`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if (response.ok) {
          const data = await response.json();
          const playerGender = data.genero || 'M';
          const headImage = playerGender === 'F' ? '/img/rotura/cabezaroturawoman.png' : '/img/rotura/cabezarotura.png';
          
          setImages({
            gloveHandDerecha: '/img/rotura/manoizquierda.png',
            gloveHandIzquierda: '/img/rotura/manoderecha.png',
            gloveFoot: '/img/rotura/pieizquierdorotura.png',
            gloveFootLeft: '/img/rotura/piederechorotura.png',
            playerHead: headImage,
            playerBody: '/img/rotura/traje.png',
            loading: false
          });
        } else {
          setImages(prev => ({ ...prev, loading: false }));
        }
      } catch (error) {
        console.error('Error al obtener género:', error);
        setImages(prev => ({ ...prev, loading: false }));
      }
    };

    fetchGender();
  }, []);

  return images;
};

export default useRoturaImages;
